import QueryString from 'qs';
import { isArray } from 'lodash';

const getAuditTrailExportRequest = ({ payload, bulk = true }) => {
    let data = null;
    if (bulk) {
        data = {
            nama_dc: payload?.dcName?.length > 0 ? `[${payload?.dcName?.map((item) => item?.name).join(',')}]` : null,
            store_group: payload?.group?.length > 0 ? `[${payload?.group.map((item) => item?.name).join(',')}]` : null,
            date_sellout: payload?.dateSellout?.startDate
                ? `(${payload?.dateSellout?.startDate?.format('YYYY-MM-DD')},${(
                      payload?.dateSellout?.endDate ?? payload?.dateSellout?.startDate
                  )?.format('YYYY-MM-DD')})`
                : null,
            date_uploaded: payload?.dateUpload?.startDate
                ? `(${payload?.dateUpload?.startDate?.format('YYYY-MM-DD')},${(
                      payload?.dateUpload?.endDate ?? payload?.dateUpload?.startDate
                  )?.format('YYYY-MM-DD')})`
                : null,
            upload_type: payload?.uploadType ? payload?.uploadType?.name : null,
            status: payload?.status?.length > 0 ? `[${payload?.status.map((item) => item?.name).join(',')}]` : null,
        };
    } else {
        data = {
            selected_id:
                isArray(payload) && payload?.length > 0 ? `[${payload?.map((item) => item?.id).join(',')}]` : null,
        };
    }

    return QueryString.stringify(data, { skipNulls: true });
};

export default getAuditTrailExportRequest;
